import React from "react";
import styles from "./AdvancedCapabilities.module.css";
import {
    Sparkles,
    Heart,
    Zap,
    Languages,
    Shuffle,
    Radio
} from "lucide-react";

const features = [
    {
        icon: <Sparkles size={20} />,
        title: "Human-Like Speech Quality",
        desc: "Vox generates speech that's indistinguishable from real humans, with natural pauses, breathing patterns, filler words, and conversational rhythm.",
        color: "blue",
    },
    {
        icon: <Heart size={20} />,
        title: "Rich Emotional Control",
        desc: "Choose from 15+ expressive tones — empathetic, professional, friendly, urgent, calm, assertive, warm, cheerful, and more — without sounding forced or artificial.",
        color: "indigo",
    },
    {
        icon: <Zap size={20} />,
        title: "Ultra-Low Latency",
        desc: "Sub-100ms time-to-first-byte. Designed for live conversations and interactive systems, not slow, offline generation.",
        color: "purple",
    },
    {
        icon: <Languages size={20} />,
        title: "Multilingual by Design",
        desc: "Support for 10+ global languages with native accents and regional dialects. Every voice works seamlessly across all supported languages.",
        color: "green",
    },
    {
        icon: <Shuffle size={20} />,
        title: "Code-Mixing, Done Right",
        desc: "Naturally blend English with Hindi, Tamil, Telugu, and 9+ Indic languages — rendered in correct native scripts, not hacks or approximations.",
        color: "orange",
    },
    {
        icon: <Radio size={20} />,
        title: "Streaming & REST APIs",
        desc: "Use WebSocket streaming for real-time voice interactions or REST APIs for scalable batch processing. Same quality, different workloads.",
        color: "red",
    },
];

const AdvancedCapabilities = () => {
    return (
        <section className={styles.section}>
            <h2 className={styles.heading}>Advanced Capabilities</h2>
            <p className={styles.subHeading}>
                Built for real-world voice applications — not demos.
            </p>

            <div className={styles.grid}>
                {features.map((item, index) => (
                    <div
                        key={index}
                        className={`${styles.card} ${styles[item.color]}`}
                        style={{ animationDelay: `${index * 0.1}s` }}
                    >
                        <div className={styles.iconBox}>{item.icon}</div>
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default AdvancedCapabilities;